import {
  VpButton,
  VpCheckbox,
  VpCheckboxLabel,
  VpDivider,
} from '@vtmn-play/react';
import { VtmnList, VtmnListItem } from '@vtmn/react';
import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '../filterBar';
import '../navigation-bar.css';
import { IMenuChipsProps } from './menuChip.props';

export const MenuChip = ({
  availableFilters = [],
  selectedFilters,
  setSelectedFilters,
  identifier,
  setMenuFilterVisibility,
}: IMenuChipsProps) => {
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  useEffect(() => {
    const newItems: string[] = [
      'productNatureIds',
      'retailFamilyIds',
      'segmentationIds',
      'sportIds',
    ].includes(identifier)
      ? selectedFilters[identifier].toString().split(',')
      : (selectedFilters[identifier] as string[]);

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSelectedItems(newItems);
  }, []);

  const shouldBeChecked = (filter: Filter): boolean =>
    selectedItems.includes(filter.id);

  const handleChange = (e: FormEvent<HTMLInputElement>, filterId: string) => {
    if (e.currentTarget.checked) {
      selectedItems[0] !== ''
        ? setSelectedItems([...selectedItems, filterId])
        : setSelectedItems([filterId]);
    } else {
      setSelectedItems(selectedItems.filter((id) => id !== filterId));
    }
  };

  const handleUnselectAll = () => {
    handleSave([]);
  };

  const handleSave = (items: string[]) => {
    const needFormatting = [
      'productNatureIds',
      'retailFamilyIds',
      'segmentationIds',
      'sportIds',
    ].includes(identifier);
    setSelectedFilters({
      ...selectedFilters,
      [identifier]: needFormatting ? items.map((id) => parseInt(id)) : items,
    });
    setMenuFilterVisibility({
      productManager: false,
      productNature: false,
      retailFamily: false,
      userSegmentation: false,
      sports: false,
      status: false,
    });
  };

  const renderFilterItems = () => {
    const renderLabelText = (af: Filter) => {
      if (identifier === 'status') {
        return `${af.label}`;
      } else {
        if (af.label?.length > 0) {
          return `${af.id} - ${af.label}`;
        } else {
          return `${af.id}`;
        }
      }
    };
    return availableFilters.map((filter, index) => {
      return (
        <VtmnListItem key={`list-item-${identifier}-${filter.id}`}>
          <VpCheckbox
            id={`checkbox-${identifier}-${filter.id}`}
            data-testid={`checkbox-${identifier}-${index}`}
            labelSlot={
              <VpCheckboxLabel>{renderLabelText(filter)}</VpCheckboxLabel>
            }
            onChange={(event) => event && handleChange(event, filter.id)}
            checked={shouldBeChecked(filter)}
            value={filter.id}
          />
        </VtmnListItem>
      );
    });
  };

  return (
    <VtmnList
      data-testid={`menu-chip_${identifier}`}
      className="list-items-container"
    >
      <div className="list-items">{renderFilterItems()}</div>
      <VpDivider />
      <div className="vtmn-flex vtmn-justify-end vtmn-p-4 vtmn-gap-x-4">
        <VpButton
          data-testid="menu-chip_button_unselect-all"
          size="small"
          shape="squared"
          variant="tertiary"
          onClick={handleUnselectAll}
        >
          {t('unselect_all')}
        </VpButton>
        <VpButton
          data-testid="menu-chip_button_save"
          size="small"
          shape="squared"
          onClick={() => handleSave(selectedItems)}
        >
          {t('save')}
        </VpButton>
      </div>
    </VtmnList>
  );
};
